import React, { Component } from "react";

// Redux
import { connect } from "react-redux";

import { Row, Col } from "reactstrap";

import Loading from "components/Loading";

class Confirmacion extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <React.Fragment>
        {this.props.loading ?
          <Row>
            <Col className="d-flex justify-content-center">
              <Loading />
            </Col>
          </Row>
          : <>
          <Row className="mt-3">
            <Col>
              <div className="form-group">
                <label>Nombre</label><br />
                <span>{this.props.wizardData['Datos'] ? this.props.wizardData['Datos'].values.firstName : '-'}</span>
              </div>
            </Col>
            <Col>
              <div className="form-group">
                <label>Apellido</label><br />
                <span>{this.props.wizardData['Datos'] ? this.props.wizardData['Datos'].values.lastName : '-'}</span>
              </div>
            </Col>
          </Row>
            <Row className="mt-3">
              <Col>
                <div className="form-group">
                  <label>Género</label><br />
                  <span>{this.props.wizardData['Datos'] ? this.props.wizardData['Datos'].values.gender || '-' : '-'}</span>
                </div>
              </Col>
              <Col>
                <div className="form-group">
                  <label>Nacionalidad</label><br />
                  <span>{this.props.wizardData['Datos'] ? this.props.wizardData['Datos'].values.nationality || '-' : '-'}</span>
                </div>
              </Col>
            </Row>
          <Row className="mt-3">
          <Col>
            <div className="form-group">
              <label>Tipo de documento</label><br />
              <span>
                {this.props.wizardData['Datos']?.values?.docType === 'pasaporte' && 'Pasaporte'}
                {this.props.wizardData['Datos']?.values?.docType === 'dni' && 'DNI'}
                {this.props.wizardData['Datos']?.values?.docType === 'rut' && 'RUT'}
              </span>
            </div>
          </Col>
          <Col>
            <div className="form-group">
              <label>Número de documento</label><br />
              <span>
                {this.props.wizardData['Datos']?.values?.docType === 'pasaporte' && this.props.wizardData['Datos']?.values?.passport}
                {this.props.wizardData['Datos']?.values?.docType === 'dni' && this.props.wizardData['Datos']?.values?.dni}
                {this.props.wizardData['Datos']?.values?.docType === 'rut' && this.props.wizardData['Datos']?.values?.rut}
              </span>
            </div>
          </Col>
        </Row>
          <Row className="mt-3">
               <Col>
              <div className="form-group">
                <label>Teléfono celular</label><br />
                <span>{this.props.wizardData['Datos'] ? this.props.wizardData['Datos'].values.phone : '-'}</span>
              </div>
            </Col>
            <Col>
              <div className="form-group">
                <label>Email</label><br />
                <span>{this.props.wizardData['Datos'] ? this.props.wizardData['Datos'].values.email : '-'}</span>
              </div>
            </Col>
          </Row>
        </>
      }
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const { loading } = state.Home;
  return {
    loading
  };
}

export default connect(mapStateToProps, {
}, null, { forwardRef: true })(Confirmacion);

